import { PlayerActiveBonusesModal as Modal } from "./modal";

const CurrentBonus = { Modal };

export default CurrentBonus;
